import PropTypes from 'prop-types'
import classNames from 'classnames'
import { pluralize } from '../../../utility/helperFunctions'
import moment from 'moment'
import styles from './RosterLabels.module.scss'
import Toggle from '../../common/Toggle'

const RosterLabels = ({ event, handleRSVPToggle }) => {
  const students = event.students

  const rsvpMessage = () => {
    const daysAgo = event.lastRsvp?.daysAgo ? `${event.lastRsvp.daysAgo} ${pluralize('Day', event.lastRsvp.daysAgo)} ago` : 'today'

    switch (event.rsvpStatus) {
      case 'open':
        return event.nextRsvp
          ? `RSVP Reminder - Sending in ${event.nextRsvp} Days, ${moment(new Date(), 'DD-MM-YYYY').add(event.nextRsvp, 'days').format('Do MMMM')}`
          : `Last RSVP Reminder  - Sent ${daysAgo}, ${moment(event.lastRsvp.date).format('Do MMMM')}`
      case 'closed':
        return `RSVP Closed${ event.rsvpClosedReason
          ? ` - ${event.rsvpClosedReason}`
          : event.lastRsvp
            ? `, Last RSVP Reminder  - Sent ${daysAgo}, ${moment(event.lastRsvp.date).format('Do MMMM')}`
            : ''} `
      case 'disabled':
        return 'RSVP Disabled'
      default:
        null
    }
  }

  return (
    <div className={classNames(styles.rosterLabels, 'd-flex flex-wrap')}>
      <div className={classNames(styles.labelWrapper, styles.golfersLabel)}>
        <span className='mx-auto'>{students.length} {pluralize('Golfer', students.length)}</span>
      </div>

      {event.golferLimit &&
      <div className={classNames(styles.labelWrapper, styles.capacityLabel)}>
        <div className={styles.hl}/>
        <div className={styles.iconWrapper}>
          <i className='fa fa-flag' aria-hidden='true'/>
        </div>
        <div className={styles.textWrapper}>
          <span>{event.golferLimit}</span>
          <span>Capacity</span>
        </div>
      </div>
      }

      <div className={classNames(styles.labelWrapper, styles.attendingLabel)}>
        <div className={styles.hl}/>
        <div className={styles.iconWrapper}>
          <i className='fa fa-check' aria-hidden='true'/>
        </div>
        <div className={styles.textWrapper}>
          <span>{event.attendingCount}</span>
          <span>Attending</span>
        </div>
      </div>

      <div className={classNames(styles.labelWrapper, styles.notAttendingLabel)}>
        <div className={styles.hl}/>
        <div className={styles.iconWrapper}>
          <i className='fa fa-times' aria-hidden='true'/>
        </div>
        <div className={styles.textWrapper}>
          <span>{event.notAttendingCount}</span>
          <span>Not Attending</span>
        </div>
      </div>

      <div className={classNames(styles.labelWrapper, styles.noResponseLabel)}>
        <div className={styles.hl}/>
        <div className={styles.iconWrapper}>
          <i className='fa fa-question' aria-hidden='true'/>
        </div>
        <div className={styles.textWrapper}>
          <span>{event.noResponseCount}</span>
          <span>No Response</span>
        </div>
      </div>

      {event.nextRsvp || event.lastRsvp ?
        <div className={classNames(styles.labelWrapper, styles.rsvpLabel, 'px-3')}>
          <div className={styles.iconWrapper}>
            <i className='fa fa-envelope' aria-hidden='true'/>
          </div>
          <div className={classNames('w-100', styles.textWrapper)}>
            <div className='d-flex align-items-center justify-content-between w-100'>
              <span>{rsvpMessage()}</span>
              {event.rsvpStatus !== 'closed' &&
              <div className={classNames('d-flex align-items-center py-3', styles.toggleWrapper)}>
                <Toggle
                  name='enableRSVP'
                  icons={false}
                  checked={event.rsvpStatus === 'open'}
                  onChange={handleRSVPToggle}
                />
                <label htmlFor='enableRSVP' className='ml-3 mb-0'>{`RSVP ${event.rsvpStatus === 'open' ? 'Open' : 'Closed'}`}</label>
              </div>
              }
            </div>
          </div>
        </div>
        :
        event.daysUntilEvent > 0 ?
          <div className={classNames(styles.labelWrapper, 'px-3')}>
            <div className={styles.textWrapper}>
              <span>Event in {event.daysUntilEvent} {pluralize('Day', event.daysUntilEvent)}</span>
            </div>
          </div>

          :
          event.daysUntilEvent === 0 ?
            <div className={classNames(styles.labelWrapper, 'px-3')}>
              <div className={styles.textWrapper}>
                <span className={styles.eventToday}>Event day: Today!</span>
              </div>
            </div>
            :
            null
      }
    </div>
  )
}

RosterLabels.propTypes = {
  event: PropTypes.shape({
    students: PropTypes.array.isRequired,
    nextRsvp: PropTypes.number,
    daysUntilEvent: PropTypes.number,
    attendingCount: PropTypes.number,
    notAttendingCount: PropTypes.number,
    noResponseCount: PropTypes.number,
    rsvpStatus: PropTypes.string.isRequired,
    rsvpClosedReason: PropTypes.string,
    golferLimit: PropTypes.number,
    lastRsvp: PropTypes.shape({
      daysAgo: PropTypes.number,
      date: PropTypes.string,
    }),
  }),
  handleRSVPToggle: PropTypes.func.isRequired,
}

export default RosterLabels
